import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children, requireRole }) {
  const userData = localStorage.getItem('user');

  // Check for appropriate token based on required role
  const tokenKey = requireRole === 'admin' ? 'adminToken' : 'authToken';
  const token = localStorage.getItem(tokenKey);

  // Not logged in - redirect to login
  if (!token || !userData) {
    return <Navigate to="/login" replace />;
  }

  const user = JSON.parse(userData);

  // Check if user has required role
  if (requireRole && user.role !== requireRole) {
    // Redirect to appropriate dashboard based on role
    if (user.role === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (user.role === 'customer') {
      return <Navigate to="/account" replace />;
    }
    return <Navigate to="/" replace />;
  }

  // User is authenticated and has correct role
  return children;
}

export default ProtectedRoute;
